var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2428 15.2441L13.4603 11.4616C14.4128 10.2549 14.987 8.73584 14.987 7.08333C14.987 3.1775 11.8095 0 7.90365 0C3.99781 0 0.820312 3.1775 0.820312 7.08333C0.820312 10.9892 3.99781 14.1667 7.90365 14.1667C9.55698 14.1667 11.0753 13.5933 12.282 12.64L16.0645 16.4225C16.227 16.585 16.4403 16.6667 16.6536 16.6667C16.867 16.6667 17.0803 16.585 17.2428 16.4225C17.5686 16.0967 17.5686 15.57 17.2428 15.2441ZM2.48698 7.08333C2.48698 4.09667 4.91698 1.66667 7.90365 1.66667C10.8903 1.66667 13.3203 4.09667 13.3203 7.08333C13.3203 10.07 10.8903 12.5 7.90365 12.5C4.91698 12.5 2.48698 10.07 2.48698 7.08333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.69e4fbb142e96f2a906b74a639e8098c.svg";
export { ForwardRef as ReactComponent };